<header class="sticky" [class.fixed]="stick && sticky">
  <div class="mobile-fix-option"></div>
  <div class="top-header" *ngIf="topbar">

    <!-- 
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="header-contact">
            <ul>
              <li>Bienvenido a BestTicket</li>
              <li>
                <a style="text-decoration: none; color:#999999" href="https://api.whatsapp.com/send?phone=5562017200"><i class="fa fa-phone" aria-hidden="true"></i>Contacto +52 55 62 01 72 00</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 text-end">
          <ul class="header-dropdown">
            <li class="compare">
              <a [routerLink]="['/shop/compare']"><i class="fa fa-random" aria-hidden="true"></i>Comparar</a>
            </li>
            <li></li>
            <li class="mobile-wishlist">
              <a [routerLink]="['/shop/wishlist']"><i class="fa fa-heart" aria-hidden="true" style="padding-right: 15px !important;"></i>Deseos</a>
            </li>
            <li class="onhover-dropdown mobile-account iniciar-sesion">
              <i class="ti-user" aria-hidden="true"></i> {{btnIniciar}} 
              <ul class="onhover-show-div">
                <li *ngIf="this.usuario == null">
                <a data-lng="en"  href="http://216.238.81.245/BestTicket/bestTicketAdmin">
                    Administrador
                  </a>
                </li>
                <li *ngIf="this.usuario == null" class="border border_bot">
                  <a data-lng="en" [routerLink]="['/pages/login/inicio']">
                    Iniciar Sesión
                  </a>
                </li>                
                <li *ngIf="usuario == null">
                  <a data-lng="en" href="https://GIGMAX.mx:8443/login" target="_blank" rel="noopener noreferrer">
                    Administración
                  </a>
                </li>
                <li *ngIf="this.usuario != null" class="border border_bot">
                  <a data-lng="en" [routerLink]="['/pages/panel-usuario']" style="font-weight: 900;">
                    Mi Cuenta
                  </a>
                </li>
                <li *ngIf="this.usuario != null">
                  <a data-lng="en" [routerLink]="['/pages/pedidos']">
                   Mis Pedidos
                  </a>
                </li>
                <li *ngIf="this.usuario != null">
                  <a data-lng="en" [routerLink]="['/shop/wishlist']">
                   Mis Deseos
                  </a>
                </li>
                <li *ngIf="this.usuario != null">
                  <a data-lng="en" [routerLink]="['/pages/cambiar-contrasena']">
                   Cambiar Contraseña
                  </a>
                </li>
                <li *ngIf="this.usuario != null"  class="border border_top">
                  <a data-lng="en" [routerLink]="['/home/watch']" (click)="logout()">
                    Cerrar Sesión
                  </a>
                </li>
                <li>
                  <a data-lng="es" (click)="logout()">
                    Cerrar sesión
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div> -->


  </div>
  <div class="container">
    <div class="col-sm-12">
      <div class="main-menu">
        <div class="menu-left">
          <app-left-menu></app-left-menu>
          <div class="brand-logo">
            <a routerLink="/home/watch" id="headerlogo">
							<img [ngSrc]="themeLogo" alt="logo" class="img-fluid" width="237"
								height="75" loading="lazy" />
            </a>
          </div>
        </div>
        <div class="menu-right pull-right">
          <div>
            <app-menu></app-menu>
          </div>
        <div class="cont-signin">
          <ul class="header-dropdown toggle-nav">
            <li></li>
            <li class="onhover-dropdown mobile-account iniciar-sesion">
              <i class="ti-user" aria-hidden="true"></i> 
              <span class="btn-iniciar">{{ btnIniciar }}</span>
              <ul class="onhover-show-div">
                <li *ngIf="this.usuario == null">
                  <!-- <a data-lng="en"  href="http://216.238.81.245/BestTicket/bestTicketAdmin">
                Administrador
              </a>-->
                </li>
                <li *ngIf="this.usuario == null" class="border border_bot">
                  <a data-lng="en" [routerLink]="['/pages/login/inicio']">
                    Iniciar Sesión
                  </a>
                </li>
                <li *ngIf="usuario == null">
                  <a data-lng="en" href="https://tienda.gigmax.mx:8443/login" target="_blank" rel="noopener noreferrer">
                    Administración
                  </a>
                </li>
                <li *ngIf="this.usuario != null" class="border border_bot">
                  <a data-lng="en" [routerLink]="['/pages/panel-usuario']" style="font-weight: 900;">
                    Mi Cuenta
                  </a>
                </li>
                <li *ngIf="this.usuario != null">
                  <a data-lng="en" [routerLink]="['/pages/pedidos']">
                    Mis Pedidos
                  </a>
                </li>
                <li *ngIf="this.usuario != null">
                  <a data-lng="en" [routerLink]="['/shop/wishlist']">
                    Mis Deseos
                  </a>
                </li>
                <!-- <li *ngIf="this.usuario != null">
              <a data-lng="en" [routerLink]="['/pages/cambiar-contrasena']">
               Cambiar Contraseña
              </a>
            </li> -->
                <li *ngIf="this.usuario != null" class="border border_top">
                  <a data-lng="en" [routerLink]="['/home/watch']" (click)="logout()">
                    Cerrar Sesión
                  </a>
                </li>
                <!--<li>
              <a data-lng="es" (click)="logout()">
                Cerrar sesión
              </a>
            </li>-->
              </ul>
            </li>
          </ul>
          <!-- <div class="col-lg-6 text-end">
          </div> -->
        </div>
          <div>
            <app-settings></app-settings>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>